<template>
    <div class="card">
      {{seacher}}
      <div class="card-header">
        <h4 class="card-title subject">SeachAchievements</h4>
      </div>
      <div class="card-body">
        <div class="form-row form-inline">
          <B><label for="cate">カテゴリ：</label></B>
          <v-select label="cate" class="inputbox" :clearable="false"
          @input="updateValue($event, 'inputCategory');"
          :options="YearSelectList('cate')" :value="$store.state.inputCategory" taggable 
          ></v-select>
          &nbsp;
          <B><label for="team">球団：</label></B>
          <v-select label="team" class="inputbox" :clearable="false"
          @input="updateValue($event, 'inputTeam');"
          :options="YearSelectList('team')" :value="$store.state.inputTeam" taggable 
          ></v-select>
          <!-- multiple -->
          &nbsp;
          <B v-if="YearSelectList('nen').length>2"><label for="year">年度：</label></B>
          <v-select v-if="YearSelectList('nen').length>2" label="year" class="inputbox" :clearable="false"
          @input="updateValue($event, 'inputYear');"
          :options="YearSelectList('nen')" :value="$store.state.inputYear" taggable  append-to-body
          ></v-select>
          &nbsp;
          <a v-if="CheckStamem(inputTeam, inputYear) == false"
          class="btn btn-info disabled" role="button" aria-disabled="true">スタメンをセット</a>
          <button v-else class="btn btn-info"
          @click="TeamInputLineUp(inputTeam, inputYear);">スタメンをセット</button>
      </div>
      <div>
        <a class="link" @click="FilterChange()">{{filteropen ? "フィルタ非表示": "フィルタ表示"}}<img src="../assets/filter.svg" width="16" height="16"></a>
        
        <div v-if="filteropen" class="filterbox">
          <b class="headline">検索フィルタ</b>
          <div class="form-row ">
            <div class="col-md-4 form-group" 
              v-for="(filitem, i) in FilterRecordList" :key="i">
              <div class="form-inline">
                <div class="col-md-2 ">
                  <label>{{RecordName(filitem)}}</label>
                </div>
                <div class="col-md-10">
                  <div v-if="filitem == 'name'">
                    <input class="col-md-12 form-control"
                    :value="inputName" @change="updateValue($event.target.value,'inputName')"
                    />
                  </div>
                  <div v-else>
                    <input class="col-md-5 form-control"
                    :value="SeachFilter[filitem][0]" @change="updateFilter($event.target.value, filitem, 0)"
                      />～
                    <input class="col-md-5 form-control"
                    :value="SeachFilter[filitem][1]" @change="updateFilter($event.target.value, filitem, 1)"
                      />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="subject">
      <!--<button type="button" class="btn btn-info" style="width:120px"
        @click="seachName(inputName, inputTeam, inputYear, inputCategory);">検索</button>
        -->
      </div>
      <div class="righter">計{{result_players.length}}件(2000件まで)</div>
    </div>
    <seachresult></seachresult>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Mixin from '../mixins/utility'
import seachresult from './seachresult.vue'
export default {
  name: 'NameInput',
  data() {
    return {
      filteropen: false,
    }
  },
  mixins: [Mixin],
  components: {seachresult, },
  methods: {
    updateFilter (vals, keyname, mm) {
      let r = Object.assign({}, this.SeachFilter)
      r[keyname][mm] = this.hankaku2Zenkaku(vals)
      //r[keyname][mm] = Math.abs(r[keyname])
      this.$store.commit('updateValue', {vals: r, keyname: 'SeachFilter'})
    },
    updateValue (vals, keyname) {
      if(this[keyname] != vals) {
        this.$store.commit('updateValue', {vals: vals, keyname: keyname})
        if(keyname != 'inputYear' && this.inputYear && this.YearSelectList('nen').indexOf(this.inputYear) == -1)
        this.$store.commit('updateValue', {vals: '', keyname: 'inputYear'})
        if(keyname != 'inputTeam' && this.inputTeam && this.YearSelectList('team').indexOf(this.inputTeam) == -1) 
        this.$store.commit('updateValue', {vals: '', keyname: 'inputTeam'})
      }
    },
    FilterChange (){
      console.log(this.filteropen)
      this.filteropen = !this.filteropen
    },
  },
  computed: {
    seacher() {
      return this.seachName(this.inputName, this.inputTeam, this.inputYear, this.inputCategory);
    },
    ...mapState([
      'InputNTList',
      'inputYear',
      'inputTeam',
      'inputCategory',
      'inputName',
      'SeachFilter',
    ]),
    YearSelectList () {
      return function (nt) {
        let list = []
        if(nt === 'cate'){
          list = ['ALL', 'リーグ', '球団', '選手']
        }else{
          let betu = (nt == 'nen' ? this.inputTeam : this.inputYear),
          betukey = (nt == 'nen' ? 'team' : 'nen')
          const ic = (this.inputCategory == 'リーグ' ? 'リーグ' : '選手')
          if(betu && this.InputNTList[ic][betukey][betu]) {
            list = this.InputNTList[ic][betukey][betu].list
          }else{
            list = this.InputNTList[ic][betukey]['ALL'].list
          }
          //console.log(icate);console.log(this.InputNTList);

        }
        return list////return this.nenList
      }
    }
  }
}
</script>
<style scoped>
li {
  list-style: none;
}
.tab_list {
  overflow: hidden;
}
.tab_list li {
  float: left;
  padding: 5px 5px;
  border: 1px solid #ccc;
  cursor: pointer;
  transition: .3s;
}
.tab_list li:not(:first-child) {
  border-left: none;
}
.tab_list li.active {
  background-color: #000;
  border-color: #000;
  color: #fff;
  cursor: auto;
}
.article{
  overflow: hidden;
  margin-top: -1px;
}
.article li {
  padding:5px;
  border: 1px solid #ccc;
  padding-bottom: 0px;
}
.v-select.drop-up.vs--open .vs__dropdown-toggle {
  border-radius: 0 0 4px 4px;
  border-top-color: transparent;
  border-bottom-color: rgba(60, 60, 60, 0.26);
  width: 500px;
}
.inputbox {
  min-width: 120px;
}
.link {
  color: #2d918d;
  text-decoration : underline;
}
input {
  background-color:transparent;
}

</style>
<!-- npm audit fix -->



// WEBPACK FOOTER //
// src/components/nameinput.vue